import "./CategoryDetailAppListComponent.scss";
import PropTypes from "prop-types";

/**
 * @function CategoryDetailAppListComponent test components
 * @param items list of items that contain the detailed external links in categories
 * @returns {JSX.Element}
 */
const CategoryDetailAppListComponent = ( { items } ) => {
    return (
        items && items?.length ? ( <div className="CategoryDetailAppListComponent">
            <div className="CategoryDetailAppListComponent__title mb-3" role="contentinfo" tabIndex="0" aria-label={"Approfondimenti"}> Approfondimenti:</div>
            <ul className="CategoryDetailAppListComponent__List">
                { items?.map( item => {
                    return (
                        <li key={ item?.link } className="CategoryDetailAppListComponent__ListItem">
                            <div className="d-flex">
                                <span className="material-icons-outlined" role="contentinfo" tabIndex="0" aria-label={"link"}>link</span>
                                <a target="_blank" rel="noreferrer" className="custom-link" href={ item?.link }>{ item?.descrizione }</a>
                            </div>
                        </li>
                    );
                } ) }
            </ul>
        </div> ) : null
    );
};

CategoryDetailAppListComponent.propTypes = {
    items: PropTypes.array.isRequired,
};

CategoryDetailAppListComponent.defaultProps = {
    items: [],
};

export default CategoryDetailAppListComponent;